import { jsx as r } from "react/jsx-runtime";
import e from "../CircularProgress/CircularProgress.js";
const n = "_container_1vp60_1", o = "_wrapper_1vp60_10", a = {
  container: n,
  wrapper: o
}, i = () => /* @__PURE__ */ r("div", { "data-testid": "page-loading", className: a.container, children: /* @__PURE__ */ r("div", { className: a.wrapper, children: /* @__PURE__ */ r(e, {}) }) });
export {
  i as default
};
//# sourceMappingURL=index.js.map
